import './styles.scss';
import app from '../../public-api';
import { createId } from '../../../../shared/util';
import { mountVueComponent } from '../../../../shared/components/vue-factory';

app.plugins.register({
  name: 'us:viewport:status-bar',

  extends: 'viewport',

  factory (uScope, viewport) {
    const statusBarContainer = document.createElement('div');
    statusBarContainer.id = createId();
    statusBarContainer.classList.add('us-viewport-status-bar');
    viewport.vpDivGet('outer').append(statusBarContainer);

    return {
      mountComponent (component, props) {
        const componentContainer = document.createElement('div');
        componentContainer.id = createId();
        statusBarContainer.appendChild(componentContainer);
        mountVueComponent({ el: `#${componentContainer.id}` }, component, props);
      }
    };
  }
});
